export default "__VITE_ASSET__7f41ed9e__"